import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Link } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import boqMenu from "../img/menu-BOQ.png";
import productMenu from "../img/menu-product.png";
import resourceMenu from "../img/menu-resource.png";
import settingMenu from "../img/menu-setting.png";
import "./../styles/customStyle.css";
import { useTranslation } from "react-i18next";
import { use } from "react";

export default function Home() {
  const [t, i18n] = useTranslation("global");
  const [userRole, setUserRole] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserRole"))
  );
  const [boqTeam, setBoqTeam] = React.useState("");
  // Verify user role for access page
  useEffect(() => {
    // if (!userRole) {
    //   // If no user data, redirect to login page
    //   window.location.href = "/login";
    // }
    if (userRole && userRole.role !== "admin") {
      // If not admin, set active tab from user role
      const team = userRole.role;
      if (team.length > 0) {
        // Remove suffix role _user or _admin
        const team = userRole.role.replace(/_(user|admin)$/i, "");
        // Replace _ to - for URL
        const teamFormatted = team.replace(/_/g, "-");
        setBoqTeam(teamFormatted);
      } else {
        // If no team assigned, redirect to unauthorized page
        window.location.href = "/unauthorized";
      }
    } else {
      setBoqTeam("lbd");
    }
  }, [userRole]);

  const [userData, setUserData] = React.useState(
    JSON.parse(sessionStorage.getItem("authUserData"))
  );

  const navigate = useNavigate();

  const styles = {
    searchIcon: {
      width: 50,
      height: 50,
    },
  };

  const stylesMenuIcon = {
    color: "white",
    fontFamily: "Inter, sans-serif", // Set the font family
    fontSize: "14px", // Set the font size
    fontWeight: 300, // Regular weight
    textDecoration: "none", // Remove underline
  };

  const [searchInput, setSearchInput] = useState("");

  const handleKeyDown = async (event) => {
    if (event.key === "Enter") {
      // Handle the Enter key press
      const word = searchInput.toLowerCase();
      if (word.includes("user") || word.includes("role")) {
        navigate("/user");
      } else if (word.includes("log") || word.includes("history")) {
        navigate("/log");
      } else if (
        word.includes("product") ||
        word.includes("material") ||
        word.includes("job")
      ) {
        navigate("/product");
      } else if (word.includes("ground") || word.includes("grounding")) {
        navigate("/grounding");
      } else if (
        word.includes("boq") ||
        word.includes("export") ||
        word.includes("gen")
      ) {
        navigate("/boq/lbd");
      } else if (
        word.includes("resource") ||
        word.includes("upload") ||
        word.includes("source") ||
        word.includes("master")
      ) {
        navigate("/resource");
      }
    }
  };

  return (
    <Box
      sx={{
        maxWidth: "1200px",
        margin: "auto",
        marginTop: "94px",
      }}
    >
      <Box>
        <Box
          sx={{
            paddingLeft: { lg: 30, md: 15, xs: 2 },
            paddingRight: { lg: 30, md: 15, xs: 2 },
          }}
        >
          <Box>
            <TextField
              fullWidth
              id="standard-basic"
              placeholder={t("home.txtbox.search")}
              variant="standard"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon style={{ color: "white" }} />
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiInput-underline:before": {
                  borderBottomColor: "white", // Change this to your desired border color
                },
                "& .MuiInput-underline:hover:before": {
                  borderBottomColor: "gray", // Change this to your desired border color on hover
                },
                "& .MuiInput-underline:after": {
                  borderBottomColor: "white", // Change this to your desired border color when focused
                },
                "& .MuiInputLabel-root": {
                  color: "white", // Change this to your desired label color
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "white", // Change this to your desired label color when focused
                },
                "& .MuiInputBase-input": {
                  color: "white", // Set the color of the input text
                },
              }}
              value={searchInput}
              onChange={(e) => {
                setSearchInput(e.target.value);
              }}
              onKeyDown={handleKeyDown}
            />
          </Box>
          <Box
            sx={{
              paddingTop: "50px",
              display: "flex",
              justifyContent: "space-evenly",
            }}
          >
            {/* <Link to="/boq/lbd" style={{ textDecoration: "none" }}> */}
            <Link to={`/boq/${boqTeam}`} style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton>
                  <img src={boqMenu} style={{ width: "80%", height: "auto" }} />
                </IconButton>
                <Typography sx={stylesMenuIcon}>
                  {t("home.menu.boq")}
                </Typography>
              </Box>
            </Link>

            <Link to="/product" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton>
                  <img
                    src={productMenu}
                    style={{ width: "80%", height: "auto" }}
                  />
                </IconButton>
                <Typography sx={stylesMenuIcon}>
                  {t("home.menu.product")}
                </Typography>
              </Box>
            </Link>
            <Link to="/resource" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton>
                  <img
                    src={resourceMenu}
                    style={{ width: "80%", height: "auto" }}
                  />
                </IconButton>
                <Typography sx={stylesMenuIcon}>
                  {t("home.menu.resource")}
                </Typography>
              </Box>
            </Link>
            <Link to="/user" style={{ textDecoration: "none" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <IconButton>
                  <img
                    src={settingMenu}
                    style={{ width: "80%", height: "auto" }}
                  />
                </IconButton>
                <Typography sx={stylesMenuIcon}>
                  {t("home.menu.setting")}
                </Typography>
              </Box>
            </Link>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
